export default __webpack_public_path__ + "static/media/sub-category-hair-beauty-beauty-room.2fd35df7.jpg";